import React, { useState } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import TimePeriodSelector from "./TimePeriodSelector";
import StatisticsOverview from "./StatisticsOverview";
import PerformanceChart from "./PerformanceChart";

/**
 * Performance Overview Component
 * Main component that combines statistics, time period selection, and performance chart
 */
const PerformanceOverview = ({
  statistics,
  sessions,
  findDartById,
  onTimePeriodChange,
}) => {
  const { t } = useTranslation();
  const [timePeriod, setTimePeriod] = useState("all");

  const handleTimePeriodChange = (period) => {
    setTimePeriod(period);
    onTimePeriodChange(period);
  };

  return (
    <motion.section
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="text-white p-6 bg-secondary/80 backdrop-blur-sm rounded-xl shadow-lg w-full max-w-4xl mx-auto border border-primary/20"
    >
      <h2 className="text-xl font-semibold mb-4 text-test">
        {t("history.performanceOverview")}
      </h2>

      <TimePeriodSelector
        timePeriod={timePeriod}
        onTimePeriodChange={handleTimePeriodChange}
      />

      <StatisticsOverview statistics={statistics} />

      <PerformanceChart sessions={sessions} findDartById={findDartById} />
    </motion.section>
  );
};

export default PerformanceOverview;
